import { render } from "./home_icon.vue?vue&type=template&id=6a41b7a6"
import script from "./home_icon.vue?vue&type=script&lang=js"
export * from "./home_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__